import { render, staticRenderFns } from "./affichages.vue?vue&type=template&id=db060ef8"
import script from "./affichages.js?vue&type=script&lang=js&external"
export * from "./affichages.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports